<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow" v-loading="updateloading">

      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
              <el-input placeholder="物料名称 / 物料编码 / 组织码" v-model="query.key" @keyup.enter.native="getlists"  @change="ischange=true" clearable></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" circle @click="getlists"></el-button>
              <!--
              <el-tooltip class="item" effect="dark" content="点击同步更新金蝶的公司组织业务员信息" placement="top">
                  <el-button type="danger" icon="el-icon-setting" circle @click="updateseller"></el-button>
              </el-tooltip>
              -->
              <el-button type="danger" icon="el-icon-plus" circle  @click="addcustomersinfos"></el-button>
          </el-form-item>
      </el-form>

      <el-tag type="danger" size="small" style="margin-top:10px">警告：因金蝶软件或系统信息在修改数据时不会主动同步至另一方，如其中一方有相应的数据发生修改时，请手动同步至另一方，否则将影响同步销售订单或者采购订单的数据同步</el-tag>

      <!-- 数据信息列表 -->
      <div class="backborder2" style="margin-top:10px">
      <el-table :data="goods" ref="multipleTable" style="width:100%;margin-top:10px" v-loading="loading" tooltip-effect="dark">
          <el-table-column label="id" prop="id" width="90"/>
          <el-table-column label="金蝶物料名称" prop="name" />
          <el-table-column label="关联匹配宠赞物料信息" prop="ismatch" align="center" width="170"/>
          <el-table-column label="金蝶物料规格" prop="spec" align="center" width="120"/>
          <el-table-column label="金蝶单位编码" prop="unit" align="center" width="120"/>
          <el-table-column label="金蝶物料编号" prop="code" align="center" width="120"/>
          <el-table-column label="所属金蝶组织码" prop="orgnzcode" align="center" width="120"/>
          <!--
          <el-table-column label="税率名称" prop="taxTypename" align="center" width="120"/>
          <el-table-column label="税率（%）" prop="tax" align="center" width="120"/>
          -->
          <el-table-column label="操作" align="center" width="120">
		      <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-edit" size="mini" circle  @click="getkingdeegoods(scope.row)"></el-button>
					<el-button type="warning" icon="el-icon-edit" size="mini" circle  @click="editorder(scope.row)"></el-button>
			  </template>
		  </el-table-column>
      </el-table>
      <div class="block">
	      <!--分页begin-->
	      <el-pagination
		        @size-change="goodspageSizeChange"
		        @current-change="goodspageCurrentChange"
		        :current-page="query.p"
		        :page-sizes="[10, 20, 50]"
		        :page-size="query.rollpage"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="total_rows">
	      </el-pagination>
	      <!--分页end-->
	    </div>
      </div>
      

      <!-- 编辑关联物料信息 -->
      <el-dialog title="设置匹配物料信息" :visible.sync="settingDialog" width="35%" top="10vh">
          <el-button type="danger" icon="el-icon-plus" size="mini" @click="addgoods">选择匹配商品</el-button>
          <div class="pd-goods-show" v-for="(item,index) in settingquery.goodslists" :key="index" style="margin-top:10px">
              <div class="pd-goods-show-wl">{{item.name}}</div>
              <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delselectgoods(index)"></el-button>
          </div>

          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="settingDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="small" type="danger" @click="savematchseller" style="margin-top:20px">确定</el-button>
          </div>    
      </el-dialog>

      <el-dialog title="选择商品信息" :visible.sync="addgoodsDialog" width="55%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="mini">
              <el-form-item size="small" >
                <el-select v-model="addgoodsquery.type" placeholder="请选择商品类型" @change="goodsischange=true">
                  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item size="small">
                  <el-input placeholder="编号 / 名称 / 条形码" v-model="addgoodsquery.key" clearable @keyup.enter.native="getselectgoodslists" @change="goodsischange=true"></el-input>
              </el-form-item>
              <el-form-item size="small" style="width:15%">
                  <el-button type="primary" icon="el-icon-search" circle @click="getselectgoodslists"></el-button>
              </el-form-item>
          </el-form>
          <el-table :data="goodslists" v-loading="goodsloading">
	            <el-table-column prop="name" label="商品名称" align="left"></el-table-column>	            
	            <el-table-column label="操作" width="90" align="center">
		            <template slot-scope="scope">
                    <el-button type="success" size="mini" circle icon="el-icon-check" @click="getczgoods(scope.row)"></el-button>
		            </template>
	            </el-table-column>
	        </el-table>
          <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="addgoodsquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="addgoodsquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="goods_row">
	          </el-pagination>
	          <!--分页end-->
	        </div>
      </el-dialog>

      <!-- 新增金蝶物料信息 -->
      <el-dialog title="新增 / 编辑金蝶物料信息" :visible.sync="addcustomersDialog" width="30%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="small">
              <el-form-item label="金蝶物料名称" label-width="120">
                  <el-input placeholder="请输入金蝶物料名称" v-model="addcustomers.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="金蝶物料规格" label-width="120">
                  <el-input placeholder="请输金蝶入物料规格" v-model="addcustomers.spec" clearable></el-input>
              </el-form-item>
              <el-form-item label="金蝶物料编码" label-width="120">
                  <el-input placeholder="请输入金蝶物料编码" v-model="addcustomers.code" clearable></el-input>
              </el-form-item>
              <!--
              <el-form-item label="物料所属组织码" label-width="140">
                  <el-input placeholder="请输入供应商组织码" v-model="addcustomers.orgnzcode" clearable></el-input>
              </el-form-item>
              <el-form-item label="税率名称" label-width="140">
                  <el-input placeholder="请输入税率名称" v-model="addcustomers.taxTypename" clearable></el-input>
              </el-form-item>
              <el-form-item label="税率" label-width="140">
                  <el-input placeholder="请输入税率" v-model="addcustomers.tax" clearable><template slot="append">%</template></el-input>
              </el-form-item>
              -->
              <el-form-item label="单位拼音" label-width="140">
                  <el-input placeholder="请输入单位拼音" v-model="addcustomers.unit" clearable></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addcustomersDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="small" type="danger" @click="saveaddcustomer" style="margin-top:20px">确定</el-button>
          </div> 
      </el-dialog>


  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Kingdee/index",
      transitionshow:true,
      actionauth:'',
      warns:true,
      querychange:false,
      query: {
        act:'getgoodslists',
        token:this.$cookies.get('token'),
        key:'',
        p:1,
        rollpage:10
      },
      rows:0,
      loading:false,
      ischange:false,
      total_rows:0,
      sellers:[],
      updateloading:false,
      goods:[],

      settingDialog:false,
      settingquery: {
        act:'updategoodscontact',
        token:this.$cookies.get('token'),
        id:'',
        goodsid:'',
        goodsname:'',
        type:'',
        goodslists:[],
      },

      goods_row:0,
      goodsloading:false,
      goodslists:[],
      goodsischange:false,
      addgoodsquery: {
        act:'getselectgoods',
        token:this.$cookies.get('token'),
        type:1,
        key:'',
        p:1,
        rollpage:10
      },
      addgoodsDialog:false,
      typelists:[
        {id:1,name:'宠赞'},
        {id:2,name:'京东'}
      ],
      addcustomers: {
        act:'addkingdeegoods',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        spec:'',
        code:'',
        orgnzcode:'',
        taxType:'SL63_SYS',
        taxTypename:'',
        tax:'',
        unit:''
      },
      addcustomersDialog:false,

    }
  },

  mounted(){  
  	this.getactionauth(); //获取权限设置
    this.getlists(); //获取客户信息
  },

  methods: {

    /** 获取操作功能权限 **/
  	getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 更新客户信息 **/
    updateseller() {
      this.updateloading=true;
      var resource = this.$resource(this.url);
      resource.query({ act:'updategoods',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.updateloading=false;
          }else{
              this.updateloading=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.updateloading=false;
      }); 
    },

    /** 获取金蝶客户信息列表 **/
    getlists() {
      this.loading=true;
      this.goods=[];
      if(this.ischange==true) {
        this.query.p=1;
        this.query.rollpage=10;
      }

      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.loading=false;
          }else{
              this.goods = JSON.parse(Base64.decode(res.data.Data));
              this.total_rows=parseInt(res.data.count);
              this.loading=false;
              if(this.ischange==true) this.ischange=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.loading=false;
      }); 
    },

    goodspageSizeChange(val) {
        this.query.rollpage = val;
        this.getlists();
    },
    goodspageCurrentChange(val) {
        this.query.p = val;
        this.getlists();
    },
    

    /** 获取绑定的宠赞物料信息 **/
    editorder(item) {
      this.settingquery.id=item.id;
      this.settingDialog=true;
      var resource = this.$resource(this.url);
      resource.query({ act:'getgoodscontact',id:item.id,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.settingquery.goodsid='';
              this.settingquery.goodsname='';
              this.settingquery.type='';
              this.settingquery.goodslists=[];
              this.settingquery.goodslists=result;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      }); 
    },

    /** 删除选中匹配物料信息 **/
    delselectgoods(index) {
        //this.settingquery.goodsid='';
        //this.settingquery.goodsname='';
        //this.settingquery.type='';

        this.$delete(this.settingquery.goodslists,index);
    },

    /** 获匹配商品信息 **/
    addgoods() {
      this.addgoodsDialog=true;
      this.addgoodsquery.key='';
      this.addgoodsquery.type=1;
      this.addgoodsquery.p=1;
      this.addgoodsquery.rollpage=10;
      this.getselectgoodslists();
    },

    /** 获取商品信息列表 **/
    getselectgoodslists() {
      if(this.goodsischange==true) {
        this.addgoodsquery.p=1;
        this.addgoodsquery.rollpage=10;
      }

      this.goodsloading=true;
      var resource = this.$resource(this.url);
      resource.query({ act:'addselectgoodslists',type:this.addgoodsquery.type,key:this.addgoodsquery.key,p:this.addgoodsquery.p,rollpage:this.addgoodsquery.rollpage,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.goodsloading=false;
          }else{
              this.goodslists = JSON.parse(Base64.decode(res.data.Data));
              this.goods_row=parseInt(res.data.count);
              this.goodsloading=false;
              if(this.goodsischange==true) this.goodsischange=false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.goodsloading=false;
      }); 
    },

    pageSizeChange(val) {
        this.addgoodsquery.rollpage = val;
        this.getselectgoodslists();
    },
    pageCurrentChange(val) {
        this.addgoodsquery.p = val;
        this.getselectgoodslists();
    },

    /** 选择当前商品 **/
    getczgoods(item) {
      this.addgoodsDialog=false;
      //this.settingquery.goodsid=item.id;
      //this.settingquery.goodsname=item.name;
      //this.settingquery.type=this.addgoodsquery.type;

      var isadd=false;
      this.settingquery.goodslists.forEach(function(tt,ii) {
          if(tt.id==item.id && tt.type==item.type) isadd=true;
      });
      if(!isadd) this.settingquery.goodslists.push({id:item.id,name:item.name,type:item.type});
    },

    /** 更新关联商品信息 **/
    savematchseller() {
      var resource = this.$resource(this.url);
      resource.save(this.settingquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.settingDialog=false;
              this.getlists();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      }); 
    },


    /** 获取金蝶物料信息 **/
    getkingdeegoods(item) {
        this.addcustomers.act='editkingdeegoods';
        this.addcustomers.id=item.id;
        this.addcustomers.name=item.name; 
        this.addcustomers.spec=item.spec; 
        this.addcustomers.code=item.code;
        this.addcustomers.unit=item.unit;
        this.addcustomersDialog=true;
    },

    /** 新增金蝶客户信息 **/
    addcustomersinfos() {
        this.addcustomers.act='addkingdeegoods';
        this.addcustomers.id='';
        this.addcustomers.name=''; 
        this.addcustomers.spec=''; 
        this.addcustomers.code='';
        this.addcustomers.orgnzcode='';
        this.addcustomers.taxTypename='';
        this.addcustomers.tax='';
        this.addcustomers.unit='';
        this.addcustomersDialog=true;
    },

    /** 保存金蝶客户信息 **/
    saveaddcustomer() {
        var resource = this.$resource(this.url);
		    resource.save(this.addcustomers).then((res) => {
		        if(res.data.Result>0){
			          if(res.data.Result=='70001') this.$router.push('/login')
			          this.$message.error(res.data.Message);
		        }else{
			          this.getlists();
                this.addcustomersDialog=false;
		        }
		    }).catch((res) => {
		        //this.$message.error(this.GLOBAL.errortext);
		    });
    },


  },

  components:{
    
  }
}
</script>
<style>
.customerkingdee,.customercz {float:left;width:100%}
.customerkingdee,.customercz {float:left;width:100%}
.customerkingdee p,.customercz p {float:left;width:100%;font-size:14px;line-height:14px}
.customerkingdee .number,.customerkingdee .compny,.customercz .number,.customercz .compny {float:left;width:100%;margin-bottom:10px}
.customerkingdee .number i,.customercz .number i  {float:left;font-style:normal;margin-right:5px;font-size:12px;color:#fff;line-height:12px;padding:3px;border-radius:5px;background:#409EFF}
.customerkingdee .number span,.customercz .number span {float:left;font-size:12px;color:#666666;line-height:12px;margin-top:2px}
.customerkingdee .compny i,.customercz .compny i  {float:left;font-style:normal;margin-right:5px;font-size:12px;color:#fff;line-height:12px;padding:3px;border-radius:5px;background:#67C23A}
.customerkingdee .compny span,.customercz .compny span {float:left;font-size:12px;color:#666666;line-height:12px;margin-top:2px}
.pd-goods-show {float:left;width:96%;background:rgb(221,221,221);border-radius:5px;padding:10px 2%}
.pd-goods-show-wl {float:left;width:85%;color:red;font-size:12px;line-height:20px;}
.pd-goods-show .el-button--mini.is-circle {margin:0 0 0 5%}
</style>


// WEBPACK FOOTER //
// src/components/kingdee/KDgoods.vue